<app-dialog
  #dialog
  [key]="'link-meeting'"
  [action]="'link-meeting'"
  [headerTheme]="'simple'"
  [title]="'Vincular reunião'"
  [maxWidth]="'920px'">
  <div class="link-meeting">
    @if (ligacao(); as meeting) {
      <div class="link-meeting__meeting">
        <span class="link-meeting__meeting-icon" aria-hidden="true"
          ><i class="pi pi-video"></i
        ></span>
        <div>
          <strong>{{ meeting.title }}</strong>
          <span>{{ meeting.scheduledStartAt | vaultDateTime }}</span>
        </div>
      </div>
    }

    <app-meeting-link-fields #campos (selecaoChange)="selecao.set($event)" />

    <fieldset class="link-meeting__grupo">
      <legend class="link-meeting__titulo">
        <i class="pi pi-building" aria-hidden="true"></i> Empresas associadas
      </legend>
      <p class="link-meeting__descricao">
        Todas as empresas de que a call tratou, sem parceiro nem deal. Desmarcar desfaz o vínculo.
      </p>

      <app-select
        [multiple]="true"
        [label]="'Empresas'"
        [placeholder]="carregandoEmpresas() ? 'Carregando empresas...' : 'Selecione as empresas'"
        [options]="empresas()"
        [loading]="carregandoEmpresas()"
        [emptyMessage]="'Nenhuma empresa encontrada.'"
        [ngModel]="associadas()"
        (ngModelChange)="aoMudarAssociadas($event)" />
    </fieldset>
  </div>

  <ng-template #footer>
    <div class="dialog__footer">
      <p class="dialog__footer-note">
        <i class="pi pi-info-circle" aria-hidden="true"></i>
        O parceiro só vê a reunião na aba Reuniões do deal se todas as empresas dela forem dele.
      </p>
      <div class="dialog__footer-actions">
        <app-button
          [label]="'Cancelar'"
          [theme]="'outline-grey'"
          [type]="'button'"
          (sendButtonClick)="fechar()" />
        <app-button
          [label]="'Vincular'"
          [icon]="'pi pi-link'"
          [disabled]="!isFormValid()"
          [isLoading]="gravando()"
          [loadingText]="'Vinculando...'"
          [type]="'button'"
          (sendButtonClick)="submitAction()" />
      </div>
    </div>
  </ng-template>
</app-dialog>
